import { Main } from "components/pages";
import { NewAddresseesTemplate } from "templates/NewAddresseesTemp";

export default function NewAddressees() {
  return (
    <>
      <Main>
        <section>
          <NewAddresseesTemplate />
        </section>
      </Main>
    </>
  );
}
